import "ol/ol.css";
import "ol-layerswitcher/dist/ol-layerswitcher.css";
import '/css/style.css';

import {Map, View, Overlay} from 'ol';
import {defaults} from 'ol/interaction';
import {FullScreen, defaults as defaultControls} from 'ol/control';
import {Group as LayerGroup} from 'ol/layer';
import TileLayer from 'ol/layer/Tile';
import OSM from 'ol/source/OSM';
import XYZ from 'ol/source/XYZ';
import GPX from 'ol/format/GPX';
import GeoJSON from 'ol/format/GeoJSON';
import WMTS from 'ol/source/WMTS';
import VectorLayer from 'ol/layer/Vector';
import WMTSTileGrid from 'ol/tilegrid/WMTS';
import {fromLonLat, get as getProjection} from 'ol/proj';
import VectorSource from 'ol/source/Vector';
import Feature from 'ol/Feature';
import Point from 'ol/geom/Point';
import {Style, Fill, Circle, Stroke, Icon, Text} from 'ol/style';
import {getWidth, createEmpty, extend, isEmpty} from 'ol/extent';
import LayerSwitcher from 'ol-layerswitcher';

// Global data
   const url = window.location.href;
   if (document.domain == "localhost"){
      var baseURL =  ''                 // Lokal, über Web-Server Apache2
   }else{
      var baseURL =  ''                      // Online auf Server
   }
   
   const store = {};
   const form = document.forms[0];

   var hoverOverlay, hoverContainer, hoverContent;

   var isMobile = window.matchMedia("only screen and (max-width: 760px)");

   //-------------------------------------------------------------------
   //   Layer-Stil   
   //-------------------------------------------------------------------
   var styleFunction = function(feature) {
      if (feature.getGeometry().getType() == 'Point'){
         //console.log("Point "+feature.get("name"));
         if (feature.get('wpt') == 'no'){
            style = new Style ({ visibility: 'hidden' });
         }else{
            style =
               new Style({
                  image: new Icon({
                     anchor: [0.5, 1],
                     src: baseURL + '/icons/marker.png'
                  }),
                  text: new Text({
                     text: feature.get("name"),
                     font: 'bold italic 16px Calibri,sans-serif',
                     offsetY: -30,
                     fill: new Fill({
                         color: '#000'
                     }),
                     stroke: new Stroke({
                         color: '#fff',
                         width: 3
                     }),
                     textAlign: 'center',
                     overflow: false,
                 })
               })
         }
      }else if (feature.getGeometry().getType() == 'LineString'){
         //console.log("LineString "+feature.get("name"));
         style = 
            new Style({
               stroke: new Stroke({
                     color: 'rgba( 41, 128, 185, 0.8)',
                     width: 3,
                  }),
            })
      }else if (feature.getGeometry().getType() == 'MultiLineString'){
         //console.log("MultiLineString "+feature.get("name"));
         if (feature.get('highlighted')){
            style = new Style ({
               stroke: new Stroke({
                  width: 8,
                  color: [200, 0, 0, 0.6],
                  zIndex: 99,
               })
            });
         }else{
            style = new Style({
                     stroke: new Stroke({
                        color: feature.get('color'),
                        width: 5,
                        zIndex: 20,
                     }),
               })
         }
      }else if (feature.getGeometry().getType() == 'MultiPolygon'
                || feature.getGeometry().getType() == 'Polygon'){
         //console.log("MultiPolygon "+feature.get("name"));
         style = 
            new Style({
               overflow: true,
               fill: new Fill({
                  color: 'rgba(255, 10, 0, 0.25)'
               }),
               stroke: new Stroke({
                  color: '#fff',
                  width: 1.5
               }),
               text: new Text({
                  text: feature.get("name"),
                  font: 'italic bold 18px Times New Roman',
                  offsetY: 0,
                  fill: new Fill({
                     color: '#000'
                  }),
                  stroke: new Stroke({
                     color: '#fff',
                     width: 3
                  }),
                  textAlign: 'center',
                  overflow: false,
               })
            })
      }
      return style;
   };
   
   //-------------------------------------------------------------------
   // OSMIGN layers
   //-------------------------------------------------------------------
   
   const osm = new TileLayer({
      title: 'OSM',
      source: new OSM(),
      type: 'base',
      visible: false,
   });

   const cyclosm = new TileLayer({
         title: 'CyclOsm',
         source: new XYZ({
         url: 'https://{a-c}.tile-cyclosm.openstreetmap.fr/cyclosm/{z}/{x}/{y}.png',
         attributions: 
            [" © <a href='https://github.com/cyclosm/cyclosm-cartocss-style'>CyclOSM</a>",
             " © <a href='https://www.openstreetmap.org/'>OpenStreetMap</a> contributors"
            ],
      }),
      type: 'base',
      visible: false,
   });
   
   const opentopo = new TileLayer({
      title: 'OpenTopoMap',
      source: new XYZ({
         url: ' https://{a-c}.tile.opentopomap.org/{z}/{x}/{y}.png',
         attributions: 
            [" © <a href='http://opentopomap.org/'>OpenTopoMap (CC-BY-SA)</a>",
             " © <a href='https://www.openstreetmap.org/'>OpenStreetMap</a> contributors"
            ],
      }),
      type: 'base',
      visible: false,
      maxZoom: 17,
   });

   //-------------------------------------------------------------------
   // IGN layers
   //-------------------------------------------------------------------
   const resolutions = [];
   const matrixIds = [];
   const proj3857 = getProjection('EPSG:3857');
   const maxResolution = getWidth(proj3857.getExtent()) / 256;

   for (let i = 0; i < 20; i++) {
     matrixIds[i] = i.toString();
     resolutions[i] = maxResolution / Math.pow(2, i);
   }   
   const tileGrid = new WMTSTileGrid({
     origin: [-20037508, 20037508],
     resolutions: resolutions,
     matrixIds: matrixIds,
   });

   const sourceIgnPlanV2 = new WMTS({
     url: 'https://data.geopf.fr/wmts',
     layer: 'GEOGRAPHICALGRIDSYSTEMS.PLANIGNV2',
     matrixSet: 'PM',
     format: 'image/png',
     projection: 'EPSG:3857',
     tileGrid: tileGrid,
     style: 'normal',
     attributions:
       '<a href="https://www.ign.fr/" target="_blank">' +
       '<img src="https://wxs.ign.fr/static/logos/IGN/IGN.gif" title="Institut national de l\'' +
       'information géographique et forestière" alt="IGN"></a>',
   });


   const layerIgnPlanV2 = new TileLayer({
      title: 'IGN Plan V2',
      source: sourceIgnPlanV2,
      type: 'base',
      visible: false,
   });
   
   const sourceIgnOrtho = new WMTS({
     url: 'https://data.geopf.fr/wmts',
     layer: 'HR.ORTHOIMAGERY.ORTHOPHOTOS',
     matrixSet: 'PM',
     format: 'image/jpeg',
     projection: 'EPSG:3857',
     tileGrid: tileGrid,
     style: 'normal',
     attributions:
       '<a href="https://www.ign.fr/" target="_blank">' +
       '<img src="https://wxs.ign.fr/static/logos/IGN/IGN.gif" title="Institut national de l\'' +
       'information géographique et forestière" alt="IGN"></a>',
   });

   const layerIgnOrtho = new TileLayer({
      title: 'IGN Orthophoto',
      source: sourceIgnOrtho,
      type: 'base',
      visible: false,
   });

   //------------------------------------------------------------------
   // Setup Map
   //-------------------------------------------------------------------
   const map = new Map({
      target: 'map',
      layers: [layerIgnOrtho, layerIgnPlanV2, cyclosm, osm, opentopo],
      interactions: defaults({mouseWheelZoom: true, pinchRotate: false}),
      controls: defaultControls().extend([new FullScreen()]),
      view: new View({
         center: [0, 0],
         //center: [198529, 5537431],
         zoom: 0,
         constrainResolution: true,   // necessary to prevent blurry map on zooming
         maxZoom: 17,
         showFullExtent:true,
      })
   });

   var visibleLayer = sessionStorage.getItem("VisibleLayer");
   var visible = false;
   map.getLayers().forEach(function(layer) {
      if (layer.get('title') === visibleLayer){
         layer.setVisible(true);
         visible = true
      }
   });

   if (!visible){
      map.getLayers().forEach(function(layer) {
         if (layer.get('title') == "OpenTopoMap"){
            layer.setVisible(true);
         }
      });
   }

   map.getLayers().forEach(function(layer) {
      layer.on('propertychange', function(event){
         const layer = event.target;
         const prop = layer.getProperties();
         if(prop['title'] == "OpenTopoMap"){
            if( layer.getVisible()){
               map.getView().setMaxZoom(17);
            }else{
               map.getView().setMaxZoom(19);
            }
         }
         if( layer.getVisible()){
            sessionStorage.setItem("VisibleLayer", prop['title']);
         }
         return false;
      });
   });
      
   const layerSwitcher = new LayerSwitcher(
      {
        groupSelectStyle: 'children',
      }   
   );
   map.addControl(layerSwitcher);

//------------------------------------------------------------------------------
// Create track layers
//------------------------------------------------------------------------------
   var layers = [];
   if (typeof trackFile !== 'undefined'){
      for (let i = 0; i < trackFile.length; i++) {
         const first = trackFile[i].slice(0, 1);
         var trackfile = trackFile[i];
         if (first == "/"){
            trackfile = baseURL + trackFile[i];
         }
         const fType = trackfile.substring(trackfile.lastIndexOf('.')+1, trackfile.length) || trackfile;

         if (fType == "gpx"){
            var source = new VectorSource({
                url: trackfile,
                format: new GPX(),
                crossOrigin: 'anonymous',
            });
         } else if (fType == "geojson"){
            var source = new VectorSource({
                url: trackfile,
                format: new GeoJSON(),
                crossOrigin: 'anonymous',
            });
         }

         source.set('color', trackColor[i]);
         source.set('fname', trackName[i]);
         source.set('pageurl', trackPage[i]);
         source.set('wpt', trackWpt[i]);

         source.on('featuresloadend', function(event){
            //console.log("addfeature");
            var source = event.target;
            var fname = source.get('fname');
            //var feature = event.feature;
            source.forEachFeature(function(feature) {
               feature.set("fname", fname)
               feature.set("color", source.get('color'))
               feature.set("pageurl", source.get('pageurl'))
               feature.set("wpt", source.get('wpt'))
            })
         });

         var vectorLayer = new VectorLayer({
            source: source,
            //style: new Style ({ visibility: 'hidden' }),
            style: styleFunction,
            zIndex: 10+i,
         });
         vectorLayer.set('name', trackFile[i]);
         layers.push(vectorLayer);
      }
   }

//------------------------------------------------------------------------------
// Waypoints 
//------------------------------------------------------------------------------
   if (typeof wpLon !== 'undefined'){
      if (wpLon.length > 0){
         var layerMarkers = new VectorLayer({
           source: new VectorSource(),
           zIndex: 10,
         })
             
         for (let i = 0; i < wpLon.length; i++) {
            var marker = new Feature({geometry: new Point(fromLonLat([wpLon[i], wpLat[i]]))});
            // toDo: wpDescription -> PopUp
            var style = new Style({
               image: new Icon({
                  anchor: [0.5, 1],
                  src: baseURL + '/icons/marker.png'
               }),
               text: new Text({
                  text: wpTitle[i],
                  font: 'bold 16px Calibri,sans-serif',
                  offsetY: -30,
                  overflow: true,
                  fill: new Fill({
                      color: '#000'
                  }),
                  stroke: new Stroke({
                      color: '#fff',
                      width: 3
                  }),
                  textAlign: 'center'
               })
            });
            marker.setStyle(style);
            layerMarkers.getSource().addFeature(marker);
         }
      }
      layerMarkers.set('name', 'Markers');
      layers.push(layerMarkers);
   }

   //------------------------------------------------------------------------------
   // Hover overlay 
   //------------------------------------------------------------------------------
   hoverContainer = document.getElementById('hover');
   hoverContent = document.getElementById('hover-content');

   hoverOverlay = new Overlay({
     element: hoverContainer,
     autoPan: false,                   // popup may be outside of the map
     autoPanAnimation: {
       duration: 250
     }
   });

   map.addOverlay(hoverOverlay);

   var fitMap = false;
   for (var i=0; i<layers.length; i++){
     layers[i].on('postrender', function(event){
         if (fitMap){
            return
         }
         var layer = event.target;
         //console.log("rendercomplete "+ layer.get('name'));
         layer.set('postrender', true);
         var ready = true;
         var extent = createEmpty();
         for (var j=0; j<layers.length; j++){
            extent = extend(extent, layers[j].getSource().getExtent());
            //console.log(layers[j].get('name')+' '+layers[j].rendered+' '+layers[j].getSource().getExtent());
            if(!layers[j].get('postrender')){
               ready = false;
            }
         }
         //console.log('ready='+ready);
         if (ready && !isEmpty(extent)){
            map.getView().fit(extent);
//            for (var j=0; j<layers.length; j++){
//               layers[j].setStyle(styleFunction);
//            }
            fitMap = true;
          }
      });
   }

   for (var i=0; i<layers.length; i++){
      map.addLayer(layers[i])
   }

   var selectedLayer = null;

   if (typeof trackFile !== 'undefined'){
      if (trackFile.length > 1){
         // Higlight + Hover nur, wenn mehr als ein Track angezeigt wird
         map.on('pointermove', function (evt) {
            
            var hitTol = 2;
            if (isMobile.matches){
               hitTol = 15;
            }
            var layer = map.forEachFeatureAtPixel(evt.pixel, function(feature, layer) {
               if (layer == selectedLayer){
                  return true
               }

               if (selectedLayer != null){
                  hoverOverlay.setPosition(undefined);
                  // Un-highlight track
                  selectedLayer.getSource().forEachFeature(function(feature){
                     feature.set('highlighted', false);
                  })
               }

               // Show hover window
               if (feature.get("fname")){ 
                  hoverContent.innerHTML = feature.get("fname");
                  hoverOverlay.setPosition(evt.coordinate);
               }
               // Highlight track
               layer.getSource().forEachFeature(function(feature){
                  feature.set('highlighted', true);
               })
               selectedLayer = layer;
               return layer;
            }, {hitTolerance: hitTol});

            if (!layer) {
               hoverOverlay.setPosition(undefined);
               if (selectedLayer != null){
                  // Un-highlight track
                  selectedLayer.getSource().forEachFeature(function(feature){
                     feature.set('highlighted', false);
                  })
                  selectedLayer = null;
               }
            }
         })
      }

      map.on('singleclick', function (evt) {
         var feature = map.forEachFeatureAtPixel(evt.pixel, function(feature, layer) {
            var url = feature.get('pageurl');
            if (url){
               var url = baseURL + '/' + url;
               //console.log(url);
               window.location.href = url;
            }
         })
      })

   }

